export default __webpack_public_path__ + "static/media/nonetall.7460241d.png";